import { BaseApi } from './base.api.js';

export class KvkkCompanyApi extends BaseApi {
    constructor(client) {
        super(client, '/kvkk-company');
    }
}
